



















import Vue from 'vue'
import Component from 'vue-class-component'
import {State} from '../store'
import {api} from '../singleton'
@Component
export default class Header extends Vue {
  get isLoggedIn () { return this.$state.auth.isLoggedIn }
  get iconName () { return this.$route.name === 'home' ? 'menu' : 'arrow_back' }
  items: Array<{title: string}> = [
    { title: 'Help' },
    { title: 'About' },
  ]
  clickLeftIcon () {
    this.$router.push({name: 'home'})
  }
  logout () {
    api.reqMan.logout().then((r) => {
      this.$s.auth.mutations.assignLoginState(null)
      this.$router.push({name: 'login'})
    })
  }
}
